"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cn = require("classnames");
const React = require("react");
const react_css_themr_1 = require("react-css-themr");
const react_images_1 = require("react-images");
const recompose_1 = require("recompose");
const Image_1 = require("../../components/Image");
const image_1 = require("../../utils/image");
exports.defaultImageGalleryTheme = {
    root: 'w-100',
    list: {
        root: 'list pl0 flex',
        itemWrapper: 'w-third pa2 flex-none',
    },
    showMoreOverlay: 'absolute absolute--fill flex items-center justify-center bg-black-50',
    showMoreText: 'white fw7 f4 f3-ns',
    imageWrapper: 'db pointer',
    image: 'db',
    caption: 'pv2',
};
const DumpImageGallery = ({ isOpen, open, selected, onChange, className, data, theme: defaultTheme = {}, }) => {
    if (!data) {
        return null;
    }
    const { items, theme: dataTheme = {} } = data;
    const lightboxImages = items.map(item => {
        return {
            src: image_1.getImage(item.image) || '',
            caption: item.title,
            alt: item.title,
        };
    });
    const theme = { ...defaultTheme, ...dataTheme };
    const { list: listTheme = {} } = theme;
    return (React.createElement("div", { className: cn(className, theme.root) },
        React.createElement("ul", { className: listTheme.root }, items.map(({ title, image }, idx) => {
            const isLast = idx === 2;
            const hidden = idx > 2;
            const style = hidden ? { display: 'none ' } : {};
            return (React.createElement("li", { style: style, key: idx, className: listTheme.itemWrapper },
                React.createElement("a", { className: theme.imageWrapper, onClick: () => {
                        onChange(idx);
                        open(true);
                    } },
                    React.createElement("div", { className: "relative" },
                        isLast && (React.createElement("div", { className: theme.showMoreOverlay },
                            React.createElement("span", { className: theme.showMoreText },
                                items.length - 3,
                                "+"))),
                        React.createElement(Image_1.default, { className: theme.image, alt: title, title: title, data: image })),
                    React.createElement("div", { className: theme.caption }, title))));
        })),
        React.createElement(react_images_1.default, { isOpen: isOpen, currentImage: selected, images: lightboxImages, backdropClosesModal: true, onClickPrev: () => 
            // onChange(selected === 0 ? items.length : selected - 1)
            onChange(selected - 1), onClickNext: () => 
            // onChange(selected === items.length ? 0 : selected + 1)
            onChange(selected + 1), onClose: () => open(false) })));
};
const ImageGallery = recompose_1.compose(react_css_themr_1.themr('ImageGallery', {}, { composeTheme: 'softly' }), recompose_1.withState('selected', 'onChange', 0), recompose_1.withState('isOpen', 'open', false))(DumpImageGallery);
exports.default = ImageGallery;
//# sourceMappingURL=index.js.map